import PropTypes from 'prop-types'
import styled from 'styled-components'

import ColumnGridPanel from 'components/ColumnGridPanel'

import ConnectedStatusIcon from 'pages/shared/ConnectedStatusIcon'

import { percentage, friendlyName } from 'helpers/formatters'

const propTypes = {
  report: PropTypes.shape()
}

const defaultProps = {
  report: {}
}

const FURNACE_DELIVERED_CAPACITY = 'This value is the current furnace delivered capacity as a percentage of the total.'

const Status = ({ report }) => {
  const operatingStatusDisplayvalues = { SYSTEM_IDLE: 'IDLE' }

  return (
    <ColumnGridPanel.Column>
      <S.StatusColumnHeader>
        <div>Status</div>
        <S.ConnectedStatusIcon isConnected={report.connected} size="14" />
      </S.StatusColumnHeader>

      <S.Item label="Sys Mode" value={report.systemMode} hideIfValueIsNull />
      {
        report.operatingStatus &&
        !report.operatingStatus.match(/cooling/gi) &&
        !report.operatingStatus.match(/heating/gi) &&
        <S.Item label="Sys Status" value={friendlyName(report.operatingStatus, operatingStatusDisplayvalues)} hideIfValueIsNull />
      }
      {
        report.operatingStatus &&
        report.operatingStatus.match(/cooling/gi) &&
        <S.Item label="Sys Status" value={report.coolingOperatingStages.compressorOperatingStage ? `cooling STG ${report.coolingOperatingStages.compressorOperatingStage}` : 'idle'} hideIfValueIsNull />
      }
      {
        report.operatingStatus &&
        report.operatingStatus.match(/heating/gi) &&
        [
          <S.Item label="Outdoor Status" key="outdoor Status" value={report.heatingOperatingStages.outdoorOperatingStage ? `heating STG ${report.heatingOperatingStages.outdoorOperatingStage}` : 'idle'} hideIfValueIsNull />,
          <S.Item label="Indoor Status" key="indoor Status" value={report.heatingOperatingStages.indoorOperatingStage ? `heating STG ${report.heatingOperatingStages.indoorOperatingStage}` : 'idle'} hideIfValueIsNull />
        ]
      }

      <S.Item label="% Furnace Speed" value={percentage(report.furnaceDeliveredCapacity)} title={FURNACE_DELIVERED_CAPACITY} hideIfValueIsNull />

      <S.Item label="Fan Status" value={report.fanStatus} hideIfValueIsNull />

      <S.Item label="Airflow %" value={percentage(report.airFlowPercentage)} hideIfValueIsNull />
      {report.integratedDehumidificationConfig && <S.Item label="IDS" value={report.integratedDehumidificationActive ? 'Active' : 'Inactive'} hideIfValueIsNull />}

      <S.Item label="Emergency Heat" value={report.emergencyHeatEnabled ? 'Enabled' : 'Disabled'} hideIfValueIsNull />
      {report.humidifierStatus && report.humidifierStatus.toLowerCase() !== 'not installed' && <S.Item label="Humidifier" value={report.humidifierStatus} hideIfValueIsNull />}
      {report.dehumidifierStatus && report.dehumidifierStatus.toLowerCase() !== 'not installed' && <S.Item label="Dehumidifier" value={report.dehumidifierStatus} hideIfValueIsNull />}
      {report.ventilatorStatus && report.ventilatorStatus.toLowerCase() !== 'not installed' && <S.Item label="Ventilation" value={report.ventilatorStatus} hideIfValueIsNull />}
      {report.quietModeAvailable && <S.Item label="Quiet Mode" value={report.quietModeActive ? 'enabled' : 'disabled'} hideIfValueIsNull />}
    </ColumnGridPanel.Column>
  )
}

Status.propTypes = propTypes
Status.defaultProps = defaultProps

export default Status

const S = {
  StatusColumnHeader: styled(ColumnGridPanel.Column.Header)`
    display: flex;

    & > [role='button']{
      height: 20px;
    }
  `,
  ConnectedStatusIcon: styled(ConnectedStatusIcon)`
    margin-left: 5px;
    width: 16px;
    height: 16px;
  `,
  Item: styled(ColumnGridPanel.Column.Item)`
    grid-template-columns: 45% 55%;
  `
}
